
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CPMoney extends Vue {
  @Prop({ type: String, default: 'text' })
  public type: string | undefined; // <-- The native HTML <input> type

  @Prop({ default: null })
  public placeholder: string | undefined; // <-- The native HTML <input> placeholder

  @Prop()
  public value: any; // <-- The native <input> value maps to Vue's 'v-model'

  @Prop({ required: false })
  public label: string | undefined; // <-- The native HTML <label> text

  @Prop({ required: false })
  public autocomplete: string | undefined; // <-- The native HTML autocomplete field

  @Prop({ default: 0 })
  public min: number | undefined; // The minimum number or characters to be used

  @Prop({ default: null })
  public max: number | undefined; // The maximum number or characters to be used

  @Prop({ required: false })
  public modifierClass: string | undefined; // <-- Additional custom classes to be added to input element e.g. "lg-text"

  @Prop({ required: false })
  public prepend: string | undefined; // <-- prepends a character before input e.g. '$', '£' or '€'

  @Prop({ required: false })
  public append: string | undefined; // <-- prepends characters at the end of an input e.g. '%' or 'USD'

  @Prop({ required: true, default: false })
  public isInt: boolean | undefined; // <-- INT = true, Float = false

  public isInputActive = false;

  get displayValue() {
    if (this.isInputActive) {
      // fallback to display  placeholder
      if (this.value === null ) {
        return null;
      } else {
        // Cursor is inside the input field. unformat display value for user
        return this.value.toString();
      }
    } else {
      // fallback to display  placeholder
      if (this.value === null ) {
        return null;
      }
      // User is not modifying now. Format display value for user interface
      if (this.isInt) {
        return this.value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
      } else {
        return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
      }
    }
  }
  set displayValue(modifiedValue) {
    // Recalculate value after ignoring "$" and "," in user input
    let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''));
    // Ensure that it is not NaN
    if (isNaN(newValue)) {
      newValue = 0;
    }
    // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
    // $emit the event so that parent component gets it
    this.$emit('input', newValue);
  }

  public get addClasses() {
    const arr: string[] = [];
    let classes = '';
    if (this.prepend) {
      arr.push('prepend-wrapper');
    }
    if (this.append) {
      arr.push('append-wrapper');
    }
    if (arr.length > 0) {
      for (const item of arr) {
        classes = classes + ' ' + item;
      }
    }
    return classes;
  }
}
